import React, { useState } from "react";
import axios from "axios";

export default function ResetPassword() {
  // The query string is never part of pathname, so this already excludes
  // ?invite=1 with no extra handling needed.
  const token = window.location.pathname.split("/reset-password/")[1];
  // `?invite=1` is set only by the link in the platform-admin customer
  // provisioning welcome email (see platformCustomerController.js) —
  // never read by the backend, purely a frontend wording hint so a new
  // customer sees "set" rather than "reset" for a password they never
  // had in the first place.
  const isInvite = new URLSearchParams(window.location.search).get("invite") === "1";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async () => {
    setError(null);
    if (!password || password.length < 8) {
      setError("Password must be at least 8 characters");
      return;
    }
    if (password !== confirm) {
      setError("Passwords do not match");
      return;
    }
    setLoading(true);
    try {
      await axios.post("/api/auth/reset-password", { token, password });
      setStatus("success");
    } catch (err) {
      setError(
        err.response?.data?.error ||
          "Failed to reset password. Link may have expired.",
      );
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    width: "100%",
    padding: "12px 14px",
    background: "rgba(0,245,255,0.05)",
    border: "1px solid rgba(0,245,255,0.2)",
    borderRadius: 6,
    color: "#fff",
    fontSize: 14,
    outline: "none",
    boxSizing: "border-box",
    marginTop: 6,
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#0a0e1a",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "'Segoe UI', sans-serif",
      }}
    >
      <div
        style={{
          background: "rgba(0,245,255,0.03)",
          border: "1px solid rgba(0,245,255,0.15)",
          borderRadius: 12,
          padding: 40,
          width: "100%",
          maxWidth: 400,
        }}
      >
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <div
            style={{
              color: "#00f5ff",
              fontSize: 28,
              fontWeight: 700,
              letterSpacing: 2,
            }}
          >
            RIGIQ
          </div>
          <div style={{ color: "#888", fontSize: 13, marginTop: 4 }}>
            {isInvite ? "SET YOUR PASSWORD" : "SET NEW PASSWORD"}
          </div>
        </div>

        {status === "success" ? (
          <div style={{ textAlign: "center" }}>
            <div style={{ color: "#00f5ff", fontSize: 40, marginBottom: 16 }}>
              ✓
            </div>
            <p style={{ color: "#ccc", marginBottom: 8 }}>
              {isInvite ? "Password set successfully!" : "Password reset successfully!"}
            </p>
            <a
              href="/"
              style={{
                display: "inline-block",
                marginTop: 16,
                padding: "12px 24px",
                background: "#00f5ff",
                color: "#0a0e1a",
                borderRadius: 6,
                fontWeight: 700,
                textDecoration: "none",
                fontSize: 14,
              }}
            >
              LOGIN NOW →
            </a>
          </div>
        ) : (
          <>
            {!token && (
              <div
                style={{
                  color: "#ff5050",
                  textAlign: "center",
                  marginBottom: 16,
                }}
              >
                Invalid reset link. Please request a new one.
              </div>
            )}

            {error && (
              <div
                style={{
                  background: "rgba(255,80,80,0.1)",
                  border: "1px solid rgba(255,80,80,0.3)",
                  borderRadius: 6,
                  padding: "10px 14px",
                  marginBottom: 16,
                  color: "#ff5050",
                  fontSize: 13,
                }}
              >
                {error}
              </div>
            )}

            <div style={{ marginBottom: 16 }}>
              <label
                style={{
                  color: "#888",
                  fontSize: 11,
                  letterSpacing: 1,
                  display: "block",
                }}
              >
                NEW PASSWORD
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Min. 8 characters"
                style={inputStyle}
              />
            </div>

            <div style={{ marginBottom: 24 }}>
              <label
                style={{
                  color: "#888",
                  fontSize: 11,
                  letterSpacing: 1,
                  display: "block",
                }}
              >
                CONFIRM PASSWORD
              </label>
              <input
                type="password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
                placeholder="Repeat password"
                style={inputStyle}
              />
            </div>

            <button
              onClick={handleSubmit}
              disabled={loading || !token}
              style={{
                width: "100%",
                padding: "13px",
                background: loading ? "rgba(0,245,255,0.3)" : "#00f5ff",
                color: "#0a0e1a",
                border: "none",
                borderRadius: 6,
                fontWeight: 700,
                fontSize: 14,
                letterSpacing: 1,
                cursor: loading ? "not-allowed" : "pointer",
                marginBottom: 16,
              }}
            >
              {loading ? "SAVING..." : isInvite ? "SET PASSWORD →" : "SET NEW PASSWORD →"}
            </button>

            <a
              href="/"
              style={{
                display: "block",
                textAlign: "center",
                color: "#888",
                fontSize: 13,
                textDecoration: "none",
              }}
            >
              ← Back to login
            </a>
          </>
        )}
      </div>
    </div>
  );
}
